import { spawn } from 'redux-saga/effects';

import { sagas as hasTraitSagas } from './hasTraitModule';

export default function* sagas() {
	yield spawn(hasTraitSagas);
}
